import dayjs from 'dayjs';
import html2canvas from 'html2canvas';
import { ConvertedTime } from './Time';

export const downloadImage = (componentId) => {
	const component = document.getElementById(componentId);
	if (!component) return;
	html2canvas(component).then((canvas) => {
		const link = document.createElement('a');
		link.download = `image${ConvertedTime({ time: dayjs(), format: 'DD/MM/YYYY hhmmss' })}.png`;
		link.href = canvas.toDataURL();
		link.click();
		if (window.ReactNativeWebView) {
			window.ReactNativeWebView.postMessage(
				JSON.stringify({ function: 'download', base64: canvas.toDataURL() }),
			);
		}
	});
};
